import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";

const getCompanyInfo = () => {
  return axios.get(API + "company/profile/", { headers: authHeader() });
};
const getCompanyProfileImage = () => {
  return axios.get(API + "company/customerprofileimage/", { headers: authHeader() });
};
const getCompanySettingInfo = () => {
  return axios.get(API + "company/companysettingsview/", {
    headers: authHeader(),
  });
};

const getExtraFiled = () => {
  return axios.get(API + "company/extrafiledview/", { headers: authHeader() });
};

const GetCompanyInfoService = {
  getCompanyInfo,
  getCompanySettingInfo,
  getExtraFiled,
  getCompanyProfileImage
};
export default GetCompanyInfoService;
